function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'beige': 'rgb(234, 216, 171)','glad-zwart': 'rgb(0, 0, 0)','suede-zwart': 'rgb(2, 2, 2)','zwart': 'rgb(0, 0, 0)','groen': 'rgb(95, 153, 114)','antraciet': 'rgb(0, 0, 0)','cognac': 'rgb(198, 155, 120)','bruin': 'rgb(66, 49, 45)','donkerbruin': 'rgb(123, 82, 46)','vert': 'rgb(95, 153, 114)','noir': 'rgb(0, 0, 0)','noir': 'rgb(0, 0, 0)','vert': 'rgb(95, 153, 114)','marron': 'rgb(123, 82, 46)','brun': 'rgb(66, 49, 45)','marron-fonce': 'rgb(123, 82, 46)','schwarz': 'rgb(0, 0, 0)','braun': 'rgb(66, 49, 45)','braun': 'rgb(66, 49, 45)','grun': 'rgb(95, 153, 114)','anthrazit': 'rgb(0, 0, 0)','dunkelbraun': 'rgb(123, 82, 46)','wildleder-schwarz': 'rgb(2, 2, 2)','glattes-schwarz': 'rgb(0, 0, 0)','anthracite': 'rgb(0, 0, 0)','brun': 'rgb(66, 49, 45)','daim-noir': 'rgb(2, 2, 2)','noir-lisse': 'rgb(0, 0, 0)','black': 'rgb(0, 0, 0)','brown': 'rgb(66, 49, 45)','dark-brown': 'rgb(123, 82, 46)','green': 'rgb(95, 153, 114)','glossy-black': 'rgb(0, 0, 0)','black-suede': 'rgb(2, 2, 2)','brown-bear': 'rgb(66, 49, 45)','sort': 'rgb(0, 0, 0)','morkebrun': 'rgb(123, 82, 46)','gron': 'rgb(95, 153, 114)','antracit': 'rgb(0, 0, 0)','skinnende-sort': 'rgb(0, 0, 0)','ruskind-sort': 'rgb(2, 2, 2)','svart': 'rgb(0, 0, 0)','brunskallig': 'rgb(66, 49, 45)','morkbrun': 'rgb(123, 82, 46)','gron': 'rgb(95, 153, 114)','glad-svart': 'rgb(0, 0, 0)','svart-mocka': 'rgb(2, 2, 2)','bar': 'rgb(66, 49, 45)','schwarzes-veloursleder': 'rgb(2, 2, 2)','heureusement-noir': 'rgb(0, 0, 0)','noir-brillant': 'rgb(0, 0, 0)','brun-fonce': 'rgb(123, 82, 46)','blank-svart': 'rgb(0, 0, 0)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','kleur','farve','färg','farg','farge','väri',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
